import { render, staticRenderFns } from "./ChoosePlace.vue?vue&type=template&id=420b0a8a"
import script from "./ChoosePlace.vue?vue&type=script&lang=js"
export * from "./ChoosePlace.vue?vue&type=script&lang=js"
import style0 from "./ChoosePlace.vue?vue&type=style&index=0&id=420b0a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports